module.exports = __webpack_public_path__ + "img/content7-1.8d64eaa6.webp";